export class ConnectionModel {
  input!: number
  output!: number
  color!: string | null
  visible!: boolean
}
